import type { FC } from "react";
import { Select } from "../../components/select/Select";
import dayjs, { DATE_FORMAT } from "../../dayjs";
import type { ParticipantListResponse } from "./participantListApi";

interface Props {
  readonly selectedIdx: number;
  readonly participantLists: ParticipantListResponse[];
  readonly onChange: (idx: number) => void;
}

const ParticipantListVersionSelect: FC<Props> = ({ selectedIdx, participantLists, onChange }) => {
  if (participantLists.length === 0) {
    return null;
  }

  const selected = participantLists[selectedIdx];
  const helperText = selected ? `Zapisano ${dayjs(selected.createdAt).format(`${DATE_FORMAT} HH:mm`)}` : undefined;

  return (
    <Select
      label="Wersja listy"
      helperText={helperText}
      fullWidth
      value={`${selectedIdx}`}
      values={participantLists.map((_, idx) => ({
        value: `${idx}`,
        label: `Wersja ${idx + 1}${idx + 1 === participantLists.length ? " (aktualna)" : ""}`,
      }))}
      onSelect={(v) => onChange(Number.parseInt(v))}
    />
  );
};

export default ParticipantListVersionSelect;
